<template>
  <div class="drawer-content-employee">
    <div class="routes-scroll">
      <RoutesList
        v-if="hasRoutes"
        :routes="displayRoutes"
        variant="default"
        @route-click="handleRouteClick"
      />

      <div v-else class="empty-state">
        <slot name="empty">
          <span class="empty-text">{{ t('menu.noRoutes') }}</span>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserRoutes } from '@/common/composables/useUserRoutes';
import { useLocale } from '@/common/composables/useLocale';
import RoutesList from '@/layouts/components/RoutesList.vue';

const emit = defineEmits<{
  (e: 'close'): void;
}>();

const { t } = useLocale();

const { displayRoutes, hasRoutes } = useUserRoutes();

function handleRouteClick() {
  emit('close');
}
</script>

<style scoped>
.drawer-content-employee {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  min-height: 0;
}

.routes-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px;
  scrollbar-width: thin;
  scrollbar-color: var(--ion-color-medium) transparent;
}

.routes-scroll::-webkit-scrollbar {
  width: 4px;
}

.routes-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.routes-scroll::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-medium);
  border-radius: 2px;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: var(--ion-color-medium);
}

.empty-text {
  font-size: 0.9rem;
}
</style>
